import { apiSlice } from "../../app/api/apiSlice";

export const brokerUploadsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		brokerUploads: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/get_filtered_attachments/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useBrokerUploadsMutation } = brokerUploadsApiSlice;
